import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=4b2daa54&scoped=true"
import script from "./Button.vue?vue&type=script&lang=js"
export * from "./Button.vue?vue&type=script&lang=js"
import style0 from "./Button.vue?vue&type=style&index=0&id=4b2daa54&prod&scoped=true&lang=css"
import style1 from "./Button.vue?vue&type=style&index=1&id=4b2daa54&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2daa54",
  null
  
)

export default component.exports